import CardCommon from '@op/components/CardCommon';
import React, { useState } from 'react';
import TrendFilter from '../HashtagTrend/TrendFilter';
import SelectDropdown from '@opm/components/SelectDropdown';
import KolCardWrapper from './KolCardWrapper';
import HashtagVideoWrapper from './HashtagVideoWrapper';
import useIntls from '@opm/hooks/useIntls';
import { NO_DATE } from '@op/constants';

const dropdownOptions = [
  { key: 'followers', labelId: 'Followers' },
  { key: 'likes', labelId: 'Likes' },
];
export default function HashtagDetailsWrapper({
  filter,
  wholePageRef,
  translateCategory,
}: {
  filter: any;
  wholePageRef: React.RefObject<HTMLDivElement>;
  translateCategory: (value: string, isEn: boolean) => string;
}) {
  const { intl } = useIntls();
  const [detailsFilter, setDetailsFilter] = useState<any>(null);
  const [dropdownValue, setDropdownValue] = useState<string>('followers');
  const [selectedKol, setSelectedKol] = useState<Array<any>>([]);

  const changeFilter = (val: any) => {
    setDetailsFilter({
      ...filter,
      ...val,
    });
  };
  const num = filter?.time_range === 'last_7_days' ? 7 : 30;

  return (
    <CardCommon
      title={intl('Hashtag Details')}
      subFilterBeforeElement={
        <>
          <TrendFilter instanceId='hashtag_details' num={num} filterValue={filter} change={changeFilter} />
          <SelectDropdown
            value={dropdownValue}
            onChange={setDropdownValue}
            options={dropdownOptions}
            appearance="link"
            className="details-dropdown-filter"
            btnPrefixText="KOLs Sort by"
            customButton={
              <div className="select-button">
                <span className="dbo-select-flex">
                  {intl(
                    {
                      id: 'KOLs Sort by {value}',
                    },
                    {
                      value: intl(
                        dropdownOptions?.find(
                          (val) => val.key === dropdownValue,
                        )?.labelId || NO_DATE.EMPTY,
                      ),
                    },
                  )}
                </span>
              </div>
            }
          />
        </>
      }
      className="dbom-hashtag-details-wrapper"
    >
      <KolCardWrapper
        detailsFilter={detailsFilter}
        dropdownValue={dropdownValue}
        selectedKol={selectedKol}
        setSelectedKol={(kol: { anchor_uid: string }) =>
          setSelectedKol((prev) => {
            const exists = prev.find(
              (item) => item.anchor_uid === kol.anchor_uid,
            );
            if (exists) {
              return [];
            }
            return [kol];
          })
        }
      />
      <HashtagVideoWrapper
        detailsFilter={detailsFilter}
        selectedKol={selectedKol}
        setSelectedKol={setSelectedKol}
        wholePageRef={wholePageRef}
        translateCategory={translateCategory}
      />
    </CardCommon>
  );
}
